import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import StructuredData from '@/components/base/StructuredData';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterCTA from './components/NewsletterCTA';

const homeStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '欲望之岛',
      url: 'https://mindvoyage.github.io',
      description: '欲望之岛，一个让你直面内心真实渴望的沉浸式体验平台。探索属于你的欲望之岛，发现最真实的自我。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@yuwangzhidao.com',
        contactType: 'customer service',
      },
    },
    {
      '@type': 'WebSite',
      name: '欲望之岛',
      url: 'https://mindvoyage.github.io',
      description: '探索内心深处的欲望世界，发现最真实的自我。突破束缚，拥抱无限可能。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://mindvoyage.github.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '欲望之岛——探索内心深处的欲望世界',
      description: '欲望之岛，一个让你直面内心真实渴望的沉浸式体验平台。在这里，欲望与理性的边界被重新定义，探索属于你的欲望之岛。',
      url: 'https://mindvoyage.github.io',
      isPartOf: { '@id': 'https://mindvoyage.github.io/#website' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        { '@type': 'Question', name: '欲望之岛是什么？', acceptedAnswer: { '@type': 'Answer', text: '欲望之岛是一个沉浸式的自我探索平台，帮助你发现内心深处最真实的渴望。我们通过文章、活动和社区互动，为你提供一个安全、非评判的空间。' } },
        { '@type': 'Question', name: '加入欲望之岛需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '欲望之岛的基础内容对所有用户免费开放。我们相信每个人都应该有探索自我的权利。' } },
        { '@type': 'Question', name: '我的隐私如何得到保护？', acceptedAnswer: { '@type': 'Answer', text: '隐私是我们最重视的价值之一。欲望之岛采用行业领先的加密技术保护你的数据，所有个人信息严格保密。' } },
        { '@type': 'Question', name: '欲望之岛适合什么样的人？', acceptedAnswer: { '@type': 'Answer', text: '欲望之岛适合所有对自我探索感兴趣的人——无论你是在寻找人生方向、希望改善亲密关系、想要突破自我限制。' } },
        { '@type': 'Question', name: '如何开始我的探索之旅？', acceptedAnswer: { '@type': 'Answer', text: '你可以从浏览我们的精选文章开始，找到最能引起你共鸣的主题。保持一颗开放和好奇的心。' } },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <StructuredData data={homeStructuredData} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoryShowcase />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterCTA />
      </main>
      <Footer />
    </>
  );
}